import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "toolbar__group" }
const _hoisted_3 = { class: "toolbar__group" }
const _hoisted_4 = { class: "toolbar__meta" }
const _hoisted_5 = { class: "toolbar__actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("label", { class: "toolbar__label" }, "Separator", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSelected) = $event)),
        class: "toolbar__select"
      }, [...(_cache[5] || (_cache[5] = [
        _createStaticVNode("<option disabled value=\"0\" data-v-1cad5812>Separator</option><option value=\"1\" selected data-v-1cad5812>&gt; (default)</option><option value=\"2\" data-v-1cad5812>+</option><option value=\"3\" data-v-1cad5812>-</option><option value=\"4\" data-v-1cad5812>~</option>", 5)
      ]))], 512), [
        [
          _vModelSelect,
          _ctx.localSelected,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("label", { class: "toolbar__label" }, "Limit", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        min: "3",
        class: "toolbar__input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localMaxWordLength) = $event)),
        title: "This field determines the number of characters that can appear in a message. Can be set as required.\n- GW2-Mode: 197\n- Discord-Mode: 1998"
      }, null, 512), [
        [
          _vModelText,
          _ctx.localMaxWordLength,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, "Total characters: " + _toDisplayString(_ctx.totalCharacter), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn pill",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onUndo && _ctx.onUndo(...args))),
        disabled: _ctx.undoDisabled,
        title: "Undo (Ctrl+Z / Cmd+Z)"
      }, "Undo", 8, _hoisted_6),
      _createElementVNode("button", {
        class: "btn pill",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onRedo && _ctx.onRedo(...args))),
        disabled: _ctx.redoDisabled,
        title: "Redo (Ctrl+Y / Cmd+Shift+Z)"
      }, "Redo", 8, _hoisted_7),
      _createElementVNode("button", {
        type: "button",
        class: "btn pill danger",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
      }, "Delete")
    ])
  ]))
}